import { render, staticRenderFns } from "./SpinnerWheelTimeConfig.vue?vue&type=template&id=4ea88659&scoped=true&"
import script from "./SpinnerWheelTimeConfig.vue?vue&type=script&lang=js&"
export * from "./SpinnerWheelTimeConfig.vue?vue&type=script&lang=js&"
import style0 from "./SpinnerWheelTimeConfig.vue?vue&type=style&index=0&id=4ea88659&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea88659",
  null
  
)

export default component.exports